<div
  bsModal
  #requestDigitisationModal="bs-modal"
  [config]="{ show: false }"
  [rlTrapFocus]="focusTrapConfig"
  (onShown)="onRequestDigitisationShown()"
  (onHidden)="onRequestDigitisationHidden($event)"
  class="modal fade qa-requestdigitisation-modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="requestdigitisation-modal"
  aria-hidden="true"
>
  <div class="modal-dialog request-digitisation-modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title" id="requestdigitisation-modal">
          <ng-container [ngSwitch]="requestDigitisationUrl ? true : false">
            <ng-container
              *ngSwitchCase="true"
              i18n="@@requestDigitisationModal-heading-requestDigitisation"
              >Request digitisation</ng-container
            >
            <ng-container
              *ngSwitchCase="false"
              i18n="@@requestDigitisationModal-heading-pleaseChooseIdentifier"
              >Please choose {identifierType, select, isbn {ISBN} doi
              {DOI}}</ng-container
            >
          </ng-container>
        </h2>
      </div>

      <div
        class="modal-body"
        [ngClass]="{ 'contains-iframe': requestDigitisationUrl }"
      >
        <ng-container [ngSwitch]="requestDigitisationUrl ? true : false">
          <!-- iframe has tabindex="0" to ensure focus-trap will allow the user to tab into it - see https://github.com/focus-trap/tabbable#more-details -->
          <iframe
            *ngSwitchCase="true"
            [src]="requestDigitisationUrl | safeUrl"
            frameborder="0"
            tabindex="0"
          ></iframe>
          <div *ngSwitchCase="false" class="qa-select-identifier">
            <p i18n="@@requestDigitisationModal-message-pleaseChooseIdentifier">
              This item has more than one unique {identifierType, select, isbn
              {ISBN} doi {DOI}} relating to it. Please pick which
              {identifierType, select, isbn {ISBN} doi {DOI}} it is you wish to
              digitise.
            </p>
            <form [formGroup]="selectIdentifierForm">
              <div class="form-group">
                <label
                  class="form-label"
                  for="requestDigitisationModal-form-selectedIdentifier"
                  >{identifierType, select, isbn {ISBN} doi {DOI}}:</label
                >
                <div class="row">
                  <div class="col-xs-6">
                    <select
                      class="form-select"
                      id="requestDigitisationModal-form-selectedIdentifier"
                      name="selectedIdentifier"
                      formControlName="selectedIdentifier"
                    >
                      <option></option>
                      <option
                        *ngFor="let identifier of identifiers"
                        value="{{ identifier }}"
                      >
                        {{ identifier }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </ng-container>
      </div>

      <div *ngIf="!requestDigitisationUrl" class="modal-footer">
        <button
          (click)="onCancel()"
          type="button"
          class="btn btn-default qa-cancel"
          i18n="@@requestDigitisationModal-btn-cancel"
        >
          Cancel
        </button>

        <button
          [disabled]="!selectIdentifierForm.valid"
          (click)="onSelectIdentifier()"
          type="button"
          class="btn btn-primary qa-submit"
          i18n="@@requestDigitisationModal-btn-submit"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</div>
